import * as React from "react";

const SvgZip = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.412 2a2 2 0 0 0-2 2v5h-3a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h3v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.08l-.3-.293-5.6-5.5L17.222 2H9.41m3 7h-3V4h6.99l.01.009V9h5v11h-12v-1h3a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3m-8 2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm.149 4.8h2.78v-.779H5.757l1.545-2.197v-.593H4.597v.778h1.51L4.56 15.205zm3.293-3.57v3.57h.97v-3.57zm3.994.296q-.337-.295-1.015-.295H9.597V15.8h.965v-1.184h.27q.382 0 .64-.103.262-.101.418-.278.158-.175.227-.4.07-.225.07-.469 0-.544-.339-.84m-1.286.483h.249q.21 0 .31.108.1.105.1.273a.46.46 0 0 1-.066.26.37.37 0 0 1-.171.138.6.6 0 0 1-.232.042h-.19z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgZip;
